import { isInPdfContext } from './services/pdfService';

async function init() {
  try {
    if (isInPdfContext()) {
      const { initPdfApp } = await import('./index.initPdfApp');
      await initPdfApp();
    } else {
      const { initWebApp } = await import('./index.initWebApp');
      await initWebApp();
    }
  } catch (error) {
    console.error('Failed to initialize shell app:', error);
  }
}

init(); // NOSONAR typescript:S7785 - Module federation incompatible with top-level await
